import PeriodSpendings from "./PeriodSpendings";

export default class LowValueAsset {
  constructor(
    assetId,
    periodSpendings
  ) {
    this.assetId = assetId;
    this.periodSpendings = periodSpendings;
  }

  static createFromData(data) {
    let periodSpendings = [];
    for (let i = 0; i < data.periodSpendings.length; i++) {
      const element = data.periodSpendings[i];
      periodSpendings.push(PeriodSpendings.createFromData(element));
    }

    return new LowValueAsset(
      data.assetId,
      periodSpendings,
    )
  }

  static createNew() {
    let periodSpendings = [];
    periodSpendings.push(PeriodSpendings.createNew());


    return new LowValueAsset(
      null,
      periodSpendings
    );
  }
}
